export default "__VITE_ASSET__9S_9Qx6J__"